import {FormControl, IInputProps, Input, Text, View} from 'native-base';
import React from 'react';
import {AccessibilityRole, KeyboardTypeOptions} from 'react-native';

import {theme} from '../../../theme';

export interface AccessibleInputProps extends IInputProps {
  accessible: boolean;
  accessibilityLabel: string;
  accessibilityRole: AccessibilityRole;
  accessibilityHint: string;
  keyboardType: KeyboardTypeOptions;
}

export interface PRFormFieldProps {
  onChangeText: (value: string) => void;
  placeholder: string;
  dangerText?: string[];
  maskedInput?: boolean;
  onFocus?: () => void;
  testID: string;
  value: string | undefined;
  accessibility: AccessibleInputProps;
}

const PRFormField: React.FC<PRFormFieldProps> = (props) => {
  const {
    onChangeText,
    value,
    placeholder,
    dangerText,
    maskedInput,
    onFocus,
    testID,
    accessibility,
  } = props;
  const {silverSand, error} = theme.colors;

  return (
    <View width="100%" my={1} testID={`${testID}-input-wrapper`}>
      <FormControl>
        <Input
          height="56px"
          placeholder={placeholder ?? ''}
          onChangeText={onChangeText}
          value={value}
          backgroundColor="white"
          focusOutlineColor={
            dangerText && dangerText.length > 0 ? error : silverSand
          }
          fontFamily="body"
          fontWeight={400}
          fontSize={4}
          secureTextEntry={maskedInput}
          onFocus={onFocus}
          _hover={{borderColor: silverSand}}
          testID={testID + '-input'}
          accessible={accessibility?.accessible ?? true}
          accessibilityLabel={accessibility?.accessibilityLabel ?? ''}
          accessibilityRole={accessibility?.accessibilityRole ?? ''}
          accessibilityHint={accessibility?.accessibilityHint ?? ''}
          keyboardType={accessibility?.keyboardType ?? ''}
        />
      </FormControl>
      {dangerText && dangerText.length > 0 ? (
        dangerText.map((label: string, index: number) => (
          <Text
            color={error}
            fontFamily="heading"
            fontWeight={400}
            fontSize={3}
            mt={1}
            mx={3}
            key={index}
            testID={testID + '-label'}
          >
            {label}
          </Text>
        ))
      ) : (
        <View height={4} />
      )}
    </View>
  );
};

export default PRFormField;
